import { useDispatch } from 'react-redux';

import { logout } from '../store/slices/auth';

export const useLogout = () => {
  const dispatch = useDispatch();

  return async () => {
    // navigate('/login', { replace: true });
    dispatch(logout());
    window.location.href = '/login';
  };
};
